type IData = {
  title?: string
  textParagraphs: string[]
  linkId?: string
}

const dataOsteoporosisText = {
  title: 'О курсе',
  textParagraphs: [
    'Остеопороз называют «тихой эпидемией» — заболевание коварно и очень продолжительное время прогрессирует незаметно, не давая практически никаких болезненных симптомов. А основной признак болезни – болевой синдром приходит на поздних стадиях, когда процесс разрушения зашел уже очень далеко или уже после перелома. Согласно статистическим данным,  при денситометрическом обследовании, остеопороз встречается у каждой третьей женщины и у каждого пятого мужчины в возрасте старше 50 лет.',
  ],
}

const dataNeuroUniqPoints = {
  title: 'В чем уникальность курса?',
  textParagraphs: [
    'Когнитивные нарушения являются серьезными проблемами, с которыми сталкиваются пожилые люди и чаще всего это связано с тем, что нарушения часто не обнаруживаются на ранних стадиях и требуют комплексного подхода к диагностике и лечению.',
  ],
}

const dataAboutGeriatr = {
  title: 'О курсе',
  textParagraphs: [
    'Является ли старость «болезнью» и можно ли эту «болезнь» «излечить»?',
    'С лекторами курса разбираемся с чрезвычайно важной задачей: выявление и профилактика потенциальных, обусловленных возрастом, гериатрических синдромов, слабости и дефицитов и необходимостью организации мероприятий для обеспечения сохранности пожилого.',
  ],
}

const dataSomnologyText = {
  title: 'О курсе',
  textParagraphs: [
    'Нарушение сна увеличивает риск сердечно-сосудистых заболеваний, деменции, депрессии, смертности, а также ухудшает качество жизни и снижает работоспособность человека.',
    'Практически каждый из врачей сталкивается в своей клинической практике с такой проблемой, при этом мало кто имеет современные представленные о диагностике и лечении расстройств сна.',
  ],
}

const dataGktText = {
  title: 'О курсе',
  textParagraphs: [
    'В курсе «Заболевания желудочно-кишечного тракта: современные подходы к диагностике и лечению» Конышко Наталья Александровна — д.м.н. и гастроэнтеролог —  делится свежими взглядами на патологии ЖКТ и отвечает на все самые важные вопросы с позиции последних научных исследований.',
  ],
}

const dataGeriatricBasic = {
  textParagraphs: [
    'Гериатрия сегодня — самое молодое и быстро развивающееся направление медицины. По прогнозам Минздрава России, к 2050 году основными пациентами станут люди пожилого и старческого возраста, а доля людей старше 65 лет возрастет на 10 процентных пунктов и составит 24,3%.',
  ],
}

const dataMiniCardioUniqPoints = {
  title: 'В чем уникальность курса?',
  textParagraphs: [
    'Курс разработан ведущими врачами, с опытом работы в России, которые знают, как устроена система здравоохранения. А те люди, которые организовывали в России клиники сердечной недостаточности, расскажут вам о том, как она должна быть на бумаге, с какими сложностями можно столкнуться и как их можно преодолеть в реальной клинической практике.',
  ],
}

const dataModernMethodsDmp = {
  textParagraphs: [
    'Курс направлен на повышение квалификации медицинских специалистов в области дистанционного мониторинга различных групп пациентов в реальных условиях российской клинической практики',
  ],
}

export {
  dataOsteoporosisText,
  dataNeuroUniqPoints,
  dataAboutGeriatr,
  dataSomnologyText,
  dataGktText,
  dataGeriatricBasic,
  dataMiniCardioUniqPoints,
  dataModernMethodsDmp,
}
export type { IData }
